/// <reference types="chrome" />
export const isPenumbraManifestJson = (mf) => mf !== null &&
    typeof mf === 'object' &&
    'name' in mf &&
    typeof mf.name === 'string' &&
    'version' in mf &&
    typeof mf.version === 'string' &&
    'description' in mf &&
    typeof mf.description === 'string' &&
    'icons' in mf &&
    typeof mf.icons === 'object' &&
    mf.icons !== null &&
    '128' in mf.icons &&
    typeof mf.icons['128'] === 'string';
